require('./shared/layout');
import $ from 'jquery';
import Axios from 'axios';
import { parseQueryParams } from './shared/utils';
const axios = Axios.create({ withCredentials: true });

$(document).ready(function () {
  var searchParams = parseQueryParams(window.location.search || '');
  var magicToken = searchParams.access_token;

  var initAuthShowcaseCarousel = function () {
    var carousel = $('.auth-showcase-carousel');
    if (!carousel.length) return;

    var slides = carousel.find('.auth-showcase-slide');
    var controls = carousel.find('.auth-carousel-indicators button');
    if (!slides.length) return;

    var activeIndex = 0;
    var slideIntervalMs = 4000;
    var slideTimer;

    carousel.addClass('auth-carousel-js');
    slides.eq(activeIndex).addClass('is-active');
    controls.eq(activeIndex).addClass('is-active').attr('aria-selected', 'true');

    var setSlide = function (nextIndex) {
      nextIndex = Number(nextIndex);
      if (Number.isNaN(nextIndex) || nextIndex < 0 || nextIndex >= slides.length || nextIndex === activeIndex) return;

      var currentSlide = slides.eq(activeIndex);
      var nextSlide = slides.eq(nextIndex);

      currentSlide.removeClass('is-active').addClass('is-leaving');
      nextSlide.removeClass('is-leaving');

      if (nextSlide[0]) {
        nextSlide[0].offsetHeight;
      }

      nextSlide.addClass('is-active');

      if (controls.length) {
        controls.removeClass('is-active').attr('aria-selected', 'false');
        controls.eq(nextIndex).addClass('is-active').attr('aria-selected', 'true');
      }

      activeIndex = nextIndex;

      setTimeout(function () {
        currentSlide.removeClass('is-leaving');
      }, 520);
    };

    var showNextSlide = function () {
      setSlide((activeIndex + 1) % slides.length);
    };

    var restartAutoSlide = function () {
      if (slideTimer) {
        clearInterval(slideTimer);
      }

      if (slides.length > 1) {
        slideTimer = setInterval(showNextSlide, slideIntervalMs);
      }
    };

    if (controls.length) {
      controls.on('click', function () {
        setSlide(this.dataset.slide);
        restartAutoSlide();
      });
    }

    restartAutoSlide();
  };

  var setFormError = function (err) {
    $('.spinner-wrap').hide();
    $('body').addClass('errored');
    let msg = (err && err.message) || (typeof err === 'string' ? err : '');
    if (msg === 'Unauthorized') {
      msg = 'Invalid magic link'
    }

    $('body').toggleClass('has-form-error', Boolean(msg));
    $('#form_error').text(msg);
  };

  var onSignedin = function () {
    var redirecUri = searchParams.redirect;
    if (!redirecUri) {
      // check of any passed state params
      if (searchParams.state) {
        var originSearchStr;
        try {
          originSearchStr = atob(searchParams.state);
        } catch (e) { }

        if (originSearchStr) {
          var originSearchParams = parseQueryParams(originSearchStr);
          if (originSearchParams.redirect) {
            redirecUri = originSearchParams.redirect;
          }
        }
      }
    }

    if (redirecUri) {
      redirecUri = decodeURI(redirecUri);
    } else {
      redirecUri = process.env.LOGIN_REDIRECT_URL;
    }

    window.location.href = redirecUri;
  };

  var onSiginFailed = function (err) {
    setFormError(err);
  };

  var signinWithConnectCode = function () {
    var apiUri = process.env.AUTH_API_BASE + '/auth/signin/magic-link';
    axios
      .post(apiUri, { access_token: magicToken })
      .then((res) => {
        console.log('magic-login-res', res.data);
        // const body = res.data || {};
        onSignedin();
      })
      .catch((e) => {
        var err = e && e.response && e.response.data;
        onSiginFailed(err);
      });
  };

  if (magicToken) {
    signinWithConnectCode();
  } else {
    var err = {
      message: 'missing magic link token'
    };
    setFormError(err);
  }

  initAuthShowcaseCarousel();
});
